/* tjs <- index-safe.ts */

const g = globalThis;

if (g.__tjs?.configure) {
    g.__tjs.configure({ throwTypeErrors: false, logTypeErrors: false });
}
else {
    g.__tjs = {
        ...g.__tjs,
        getConfig: () => ({ throwTypeErrors: false, logTypeErrors: false }),
    };
}

export * from './index';